import { api } from '../instance';
export const trackCardMetric = (trackCardMetricDto) => {
    return api.post('/analytics/track-card-metric', trackCardMetricDto);
};
export const trackCardMetricsBatch = (trackCardMetricDtos) => {
    return api.post('/analytics/track-card-metrics-batch', trackCardMetricDtos);
};
//# sourceMappingURL=track-card-metric.api.js.map